import { useState } from 'react';
import { css } from '@emotion/react';
import { createFileRoute } from '@tanstack/react-router';
import { PasswordResetOIDC, SignInError, Layout, SignInErrorTypeKey } from '../components';

export interface ResetPasswordParams {
  username?: string;
  errorCode?: string;
}

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): ResetPasswordParams => {
    return {
      username: (search.username as string) || undefined,
      errorCode: (search.errorCode as string) || undefined,
    };
  },
  component: ResetPassword,
});

function ResetPassword() {
  const search = Route.useSearch<any>();
  const navigate = Route.useNavigate();
  const errorCode = search?.errorCode as SignInErrorTypeKey | undefined;
  const [isError, _setIsError] = useState(!!errorCode);

  return (
    <Layout background={'blue'}>
      <PasswordResetOIDC
        initialUsername={search.username ?? ''}
        onBack={(username) => {
          return navigate({
            to: '/',
            search: {
              username: username ?? '',
            },
          });
        }}
      />
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin: 0 15%;
          min-width: 300px;
          max-width: 400px;
        `}
      >
        {isError ? <SignInError errorCode={errorCode} /> : null}
      </div>
    </Layout>
  );
}
